<template>
  <div
    class="activity_answer"
    :class="[params.yunjiading ? 'jiading' : '']"  
    :style="{background:subInfo.imgurl}"
    style="background-size:100% auto"
  >
    <div class="header" :style="{'height':subInfo['imgurl']?'':'1.5rem'}">
      <div class="mvbutton small text-white" v-if="!params.yunjiading" @click="showrule=true">答题规则</div>
    </div>
    <div class="body" :style="{'background':subInfo['imgurl']?'transparent':'#f49200','margin-top':subInfo['imgurl']?'1rem':'0'}">
      <Questions
        @submitAnswer="submitAnswer"
        :questions="questions"
        v-if="questions.length"
        @selectAnswer="selectAnswer"
        :type="type"
        :answerInfo="answerInfo"
        :subInfo="subInfo"
      ></Questions>
      <Empty v-else description="暂无答题内容"></Empty>
    </div>
    <van-overlay :show="showrule">
      <div class="wrapper">
        <div class="block">
          <div class="block_header">
            <div>规则说明</div>
            <img src="../../../assets/img/common/colse.png" alt @click="showrule = false" />
          </div>
          <div class="block_body" v-html="rule" />
        </div>
      </div>
    </van-overlay>
		<img v-if="isshow" @click="toRank" class="rankIcon" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655866108-62b282fc73c75.png" alt="">
		<img v-if="isshow" @click="toRank2" class="rankIcon2" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220623/1655981439-62b4457f192c3.png" alt="">
  </div>
</template>
<script>
import "./index.less";
import Questions from "./questions/index";
import { Overlay, Empty } from "vant";

import {mapGetters} from "vuex";

export default {
  name: "answer",
	computed: {
	    ...mapGetters({
	        userInfo: "getUserInfo"
	    })
	},
  data() {
    return {
      answerInfo: {
        correctcount: 0,
        score: 0,
      },
      type: "answerList",
      showrule: false,
      rule: "",
      questions: [],
      questionname: "",
      params: this.$route.params,
      subInfo: {
        imgurl: "",
      },
			
			isshow: false,
    };
  },
  components: {
    vanOverlay: Overlay,
    Questions,
    Empty,
  },
  methods: {
		toRank(){
			this.$router.push({
				name: 'unionsrank',
				params: {
					id: this.params.aid,
					type: 1
				}
			})
		},
		toRank2(){
			window.location.href = this.subInfo.jumpurl
			// this.$router.push({
			// 	path: this.subInfo.jumpurl
			// })
		},
		
    submitAnswer() {
      this.$toast.loading({ duration: 0, loadingType: "spinner" });
      let answer = [];
      let correctcount = 0;
      for (var i in this.questions) {
        if (this.questions[i]["correct"]) correctcount++;
        if (this.questions[i]["selected"] !== undefined) {
          answer.push({
            qid: this.questions[i].qid,
            answer: this.questions[i].selected,
          });
        } else {
          this.$toast.clear();
          this.$toast.fail("请回答完所有问题后再提交");
          return;
        }
      }
      if (answer.length) {
        this.$api.answer
          .submitQuestions({ ...this.params, answer: JSON.stringify(answer) })
          .then((res) => {
            if (res.status * 1 === 200) {
              this.questions = [1];
              this.answerInfo = {
                correctcount,
                score: res.data.score,
              };
              this.type = "answerFinsh";
              this.$storage.remove(this.questionname);
            }
            this.$toast.clear();
          });
      }
    },
    selectAnswer(key, ckey) {
      var currentquestion = this.questions;
      currentquestion[key]["selected"] = ckey + 1;
      var courrent = this.cf.AesDecrypt(currentquestion[key]["answer"])
      if (ckey + 1 == courrent) {
        currentquestion[key]["correct"] = true;
      } else {
        currentquestion[key]["correct"] = false;
      }
      this.$set(this.questions, key, currentquestion[key]);
      this.$storage.set(this.questionname, currentquestion);
    },
    getQuestions() {
      this.$toast.loading({ duration: 0, loadingType: "spinner" });
      //查看本地缓存
      this.$api.answer
        .questions(this.params)
        .then((res) => {
          if (res.status * 1 === 200) {
            return res.data;
          } else {
            this.$toast.clear();
          }
        })
        .then((apires) => {
          this.rule = apires.rule;
          this.subInfo = apires.sub_info||{id:0};
          let d = new Date();
          this.questionname = [
            d.getFullYear(),
            d.getMonth(),
            d.getDay(),
            this.subInfo.id,
          ].join("-");

          if (apires.qtoday && apires.qtoday * 1 === 1) {
            this.type = "answered";
            this.questions = ["1"];
            this.$toast.clear();
            return;
          }

          this.questions = apires.questions;
          this.$storage.set(this.questionname, apires.questions);
          this.$toast.clear();
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
			console.log(this.params, '-----')
			if(this.userInfo.gid == "eStBcUhqZ0ZvRE09"){
				this.isshow = true
			}else{
				this.isshow = false
			}
      this.getQuestions();
    });
  },
};
</script>
